<template>
  <div>
    <nave />
    <router-view></router-view>
    <foter id="bot" />
  </div>
</template>

<script>
import DevicePixelRatio from '@/utils/device'
import nave from './components/nave.vue'
import foter from './components/foter.vue'

export default {
  name: 'App',
  components: { nave, foter },
  created() {
    new DevicePixelRatio().init()
  },
}
</script>

<style>
  html,body{
    padding: 0;
    margin: 0;
  }
/*包含以下五种的链接*/
a {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
}
</style>
